import Color from '../data/Color';
import { Container, getNominalBounds } from './utils';

export default class ColorBuilder {
  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  static Apply(container: Container, color: Color): void {
    if (!container || !color) {
      return;
    }

    const length = container.numChildren;
    for (let index = 0; index < length; index += 1) {
      const child = container.getChildAt(index);
      child.uncache();

      const rx = 0;
      const gx = 0;
      const bx = 0;
      const ax = 1;
      const r = color.red;
      const g = color.green;
      const b = color.blue;
      const a = 0;
      const filter = new createjs.ColorFilter(rx, gx, bx, ax, r, g, b, a);
      child.filters = [
        filter,
      ];

      const bnds = child.getBounds() || getNominalBounds(child);
      if (bnds) {
        child.cache(bnds.x, bnds.y, bnds.width, bnds.height);
      }
    }
  }
}
